import {buildQueryParams} from "../../utils";
import {useApi} from "../Api";
import {
    AdvanceBookingEntityRequest,
    AdvanceBookingEntityResponse,
    AlertEntityResponse,
    CapacityUtilizationEntityRequest,
    CapacityUtilizationEntityResponse,
    CompetitorsBenchmarksEntityRequest,
    CompetitorsBenchmarksEntityResponse,
    FormSearchAlertModel,
    PricingErrorsEntityRequest,
    PricingErrorsEntityResponse,
    RpdEntityRequest,
    RpdEntityResponse,
    UtilizationAvailabilityEntityRequest,
    UtilizationAvailabilityEntityResponse
} from "../types/alert";
import {PagedResponse} from "../types/pagination";

export const useAlertsRepository = () => {
    const {GET, POST, PUT, DELETE} = useApi();

    const PATH = "pricing/alerts";

    function getAlertPaged(filters: FormSearchAlertModel): Promise<PagedResponse<AlertEntityResponse>> {
        const query = "?";

        const queryParams = buildQueryParams(filters);

        return GET(`${PATH}${queryParams ? query + queryParams : ""}`);
    }

    function postAlert(
        alert:
            | CapacityUtilizationEntityRequest
            | UtilizationAvailabilityEntityRequest
            | CompetitorsBenchmarksEntityRequest
            | RpdEntityRequest
            | PricingErrorsEntityRequest
            | AdvanceBookingEntityRequest
    ): Promise<AlertEntityResponse> {
        return POST(`${PATH}`, alert);
    }

    function putAlert(
        alert:
            | CapacityUtilizationEntityResponse
            | UtilizationAvailabilityEntityResponse
            | CompetitorsBenchmarksEntityResponse
            | RpdEntityResponse
            | PricingErrorsEntityResponse
            | AdvanceBookingEntityResponse
    ): Promise<AlertEntityResponse> {
        return PUT(`${PATH}/${alert.uuid}`, alert);
    }

    function deleteAlert(alertId: string) {
        return DELETE(`${PATH}/${alertId}`);
    }

    return {
        putAlert,
        postAlert,
        getAlertPaged,
        deleteAlert
    };
};
